<template>
    <router-view/>
  </template>
  <script>
  export default {
      beforeRouteUpdate(to, from, next) {
          if(to.name == 'b2b-parametrizacoes'){
              next({ name: 'b2b-parametrizacoes-edit' })
          }else{
              next()
          }
      },
      created() {
          if(this.$route.name == 'b2b-parametrizacoes'){
              this.$router.push({ name: 'b2b-parametrizacoes-edit' })
          }
      }
  }
  </script>